import { ABPopupMessageLayout } from "../../common/lookups/Layouts/ABLayouts"
import { EDLookupLayout } from "../../common/lookups/Layouts/EDLayouts"
import { IDCodesLookupLayout, IDTradingPartnerLookupLayout ,IDShipViaLookupLayout,IDParticipantLookupLayout,IDTaxHeaderLookupLayout ,IDWarehouseLookupLayout,
    IDContactLookupLayout,IDProfileLookupLayout,IDExceptionCodeLookupLayout,IDWeekSettingsLookupLayout} from "../../common/lookups/Layouts/IdLayouts"
import { IMPriceScheduleLookupLayout,IMProductCategoryLookupLayout } from "../../common/lookups/Layouts/ImLayouts"
import { ACDepartmentLayout } from "../../common/lookups/Layouts/ACLayouts"
import { FAFundLayout } from "../../common/lookups/Layouts/FALayouts"
import { CAJobLayout } from "../../common/lookups/Layouts/CALayouts"

const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RECORD",
                "tableName": "IDCUSTOMER",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "R_PROFILE",
                "tableName": "IDMASTER",
                "label": "Profile",
                "type": "lookup",
                "layout":IDProfileLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": true,
            },
            {
                "name": "IDENTITYID",
                "tableName": "IDMASTER",
                "label": "Identity ID",
                "type": "text",
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "NAME",
                "tableName": "IDMASTER",
                "label": "Name",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            }
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "R_CONTACT",
                "tableName": "IDMASTER",
                "label": "Contact",
                "type": "lookup",
                "layout":IDContactLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "IDGROUP",
                "tableName": "IDMASTER",
                "label": "Group",
                "type": "lookup",
                "layout":IDCodesLookupLayout({codeType: 'Z7' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "IDSUBGROUP",
                "tableName": "IDMASTER",
                "label": "Subgroup",
                 "type": "lookup",
                "layout":IDCodesLookupLayout({codeType: 'Z8' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "REFERENCE1",
                "tableName": "IDCUSTOMER",
                "label": "Reference 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "REFERENCE2",
                "tableName": "IDMASTER",
                "label": "Reference 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DATE1",
                "tableName": "IDMASTER",
                "label": "Date 1",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DATE2",
                "tableName": "IDMASTER",
                "label": "Date 2",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }

        ]
    },
    {
        "groupId": 3,
        "fields": [


            {
                "name": "COMMENT",
                "tableName": "IDMASTER",
                "label": "Comment",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
]
const CodesLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "CustomerUSERDEFINEDCODE_1",
                "localizedField": "USERDEFINEDCODE_1",
                "tableName": "IDCUSTOMER",
                "label": "CODE 1",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDCODE_2",
                "localizedField": "USERDEFINEDCODE_2",
                "tableName": "IDCUSTOMER",
                "label": "CODE 2",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDCODE_3",
                "localizedField": "USERDEFINEDCODE_3",
                "tableName": "IDCUSTOMER",
                "label": "CODE 3",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDCODE_4",
                "localizedField": "USERDEFINEDCODE_4",
                "tableName": "IDCUSTOMER",
                "label": "CODE 4",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDCODE_5",
                "localizedField": "USERDEFINEDCODE_5",
                "tableName": "IDCUSTOMER",
                "label": "CODE 5",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDCODE_6",
                "localizedField": "USERDEFINEDCODE_6",
                "tableName": "IDCUSTOMER",
                "label": "CODE 6",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDCODE_7",
                "localizedField": "USERDEFINEDCODE_7",
                "tableName": "IDCUSTOMER",
                "label": "CODE 7",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDCODE_8",
                "localizedField": "USERDEFINEDCODE_8",
                "tableName": "IDCUSTOMER",
                "label": "CODE 8",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDCODE_9",
                "localizedField": "USERDEFINEDCODE_9",
                "tableName": "IDCUSTOMER",
                "label": "CODE 9",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDCODE_10",
                "localizedField": "USERDEFINEDCODE_10",
                "tableName": "IDCUSTOMER",
                "label": "CODE 10",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

            {
                "name": "CustomerUSERDEFINEDCODE_11",
                "localizedField": "USERDEFINEDCODE_11",
                "tableName": "IDCUSTOMER",
                "label": "CODE 11",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDCODE_12",
                "localizedField": "USERDEFINEDCODE_12",
                "tableName": "IDCUSTOMER",
                "label": "CODE 12",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDCODE_13",
                "localizedField": "USERDEFINEDCODE_13",
                "tableName": "IDCUSTOMER",
                "label": "CODE 13",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDCODE_14",
                "localizedField": "USERDEFINEDCODE_14",
                "tableName": "IDCUSTOMER",
                "label": "CODE 14",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDCODE_15",
                "localizedField": "USERDEFINEDCODE_15",
                "tableName": "IDCUSTOMER",
                "label": "CODE 15",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDCODE_16",
                "localizedField": "USERDEFINEDCODE_16",
                "tableName": "IDCUSTOMER",
                "label": "CODE 16",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDCODE_17",
                "localizedField": "USERDEFINEDCODE_17",
                "tableName": "IDCUSTOMER",
                "label": "CODE 17",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDCODE_18",
                "localizedField": "USERDEFINEDCODE_18",
                "tableName": "IDCUSTOMER",
                "label": "CODE 18",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDCODE_19",
                "localizedField": "USERDEFINEDCODE_19",
                "tableName": "IDCUSTOMER",
                "label": "CODE 19",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDCODE_20",
                "localizedField": "USERDEFINEDCODE_20",
                "tableName": "IDCUSTOMER",
                "label": "CODE 20",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "CustomerUSERDEFINEDDATE_1",
                "localizedField": "USERDEFINEDDATE_1",
                "tableName": "IDCUSTOMER",
                "label": "Date 1",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDDATE_2",
                "localizedField": "USERDEFINEDDATE_2",
                "tableName": "IDCUSTOMER",
                "label": "Date 2",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDDATE_3",
                "localizedField": "USERDEFINEDDATE_3",
                "tableName": "IDCUSTOMER",
                "label": "Date 3",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDDATE_4",
                "localizedField": "USERDEFINEDDATE_4",
                "tableName": "IDCUSTOMER",
                "label": "Date 4",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDDATE_5",
                "localizedField": "USERDEFINEDDATE_5",
                "tableName": "IDCUSTOMER",
                "label": "Date 5",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDDATE_6",
                "localizedField": "USERDEFINEDDATE_6",
                "tableName": "IDCUSTOMER",
                "label": "Date 6",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDDATE_7",
                "localizedField": "USERDEFINEDDATE_7",
                "tableName": "IDCUSTOMER",
                "label": "Date 7",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDDATE_8",
                "localizedField": "USERDEFINEDDATE_8",
                "tableName": "IDCUSTOMER",
                "label": "Date 8",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDDATE_9",
                "localizedField": "USERDEFINEDDATE_9",
                "tableName": "IDCUSTOMER",
                "label": "Date 9",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDDATE_10",
                "localizedField": "USERDEFINEDDATE_10",
                "tableName": "IDCUSTOMER",
                "label": "Date 10",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDDATE_11",
                "localizedField": "USERDEFINEDDATE_11",
                "tableName": "IDCUSTOMER",
                "label": "Date 11",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDDATE_12",
                "localizedField": "USERDEFINEDDATE_12",
                "tableName": "IDCUSTOMER",
                "label": "Date 12",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDDATE_13",
                "localizedField": "USERDEFINEDDATE_13",
                "tableName": "IDCUSTOMER",
                "label": "Date 13",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDDATE_14",
                "localizedField": "USERDEFINEDDATE_14",
                "tableName": "IDCUSTOMER",
                "label": "Date 14",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDDATE_15",
                "localizedField": "USERDEFINEDDATE_15",
                "tableName": "IDCUSTOMER",
                "label": "Date 15",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDDATE_16",
                "localizedField": "USERDEFINEDDATE_16",
                "tableName": "IDCUSTOMER",
                "label": "Date 16",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDDATE_17",
                "localizedField": "USERDEFINEDDATE_17",
                "tableName": "IDCUSTOMER",
                "label": "Date 17",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDDATE_18",
                "localizedField": "USERDEFINEDDATE_18",
                "tableName": "IDCUSTOMER",
                "label": "Date 18",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDDATE_19",
                "localizedField": "USERDEFINEDDATE_19",
                "tableName": "IDCUSTOMER",
                "label": "Date 19",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDDATE_20",
                "localizedField": "USERDEFINEDDATE_20",
                "tableName": "IDCUSTOMER",
                "label": "Date 20",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "CustomerUSERDEFINEDQUANTITY_1",
                "localizedField": "USERDEFINEDQUANTITY_1",
                "tableName": "IDCUSTOMER",
                "label": "Quantity 1",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDQUANTITY_2",
                "localizedField": "USERDEFINEDQUANTITY_2",
                "tableName": "IDCUSTOMER",
                "label": "Quantity 2",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDQUANTITY_3",
                "localizedField": "USERDEFINEDQUANTITY_3",
                "tableName": "IDCUSTOMER",
                "label": "Quantity 3",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDQUANTITY_4",
                "localizedField": "USERDEFINEDQUANTITY_4",
                "tableName": "IDCUSTOMER",
                "label": "Quantity 4",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDQUANTITY_5",
                "localizedField": "USERDEFINEDQUANTITY_5",
                "tableName": "IDCUSTOMER",
                "label": "Quantity 5",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDQUANTITY_6",
                "localizedField": "USERDEFINEDQUANTITY_6",
                "tableName": "IDCUSTOMER",
                "label": "Quantity 6",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDQUANTITY_7",
                "localizedField": "USERDEFINEDQUANTITY_7",
                "tableName": "IDCUSTOMER",
                "label": "Quantity 7",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDQUANTITY_8",
                "localizedField": "USERDEFINEDQUANTITY_8",
                "tableName": "IDCUSTOMER",
                "label": "Quantity 8",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDQUANTITY_9",
                "localizedField": "USERDEFINEDQUANTITY_9",
                "tableName": "IDCUSTOMER",
                "label": "Quantity 9",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDQUANTITY_10",
                "localizedField": "USERDEFINEDQUANTITY_10",
                "tableName": "IDCUSTOMER",
                "label": "Quantity 10",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

            {
                "name": "CustomerUSERDEFINEDQUANTITY_11",
                "localizedField": "USERDEFINEDQUANTITY_11",
                "tableName": "IDCUSTOMER",
                "label": "Quantity 11",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDQUANTITY_12",
                "localizedField": "USERDEFINEDQUANTITY_12",
                "tableName": "IDCUSTOMER",
                "label": "Quantity 12",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDQUANTITY_13",
                "localizedField": "USERDEFINEDQUANTITY_13",
                "tableName": "IDCUSTOMER",
                "label": "Quantity 13",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDQUANTITY_14",
                "localizedField": "USERDEFINEDQUANTITY_14",
                "tableName": "IDCUSTOMER",
                "label": "Quantity 14",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDQUANTITY_15",
                "localizedField": "USERDEFINEDQUANTITY_15",
                "tableName": "IDCUSTOMER",
                "label": "Quantity 15",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDQUANTITY_16",
                "localizedField": "USERDEFINEDQUANTITY_16",
                "tableName": "IDCUSTOMER",
                "label": "Quantity 16",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDQUANTITY_17",
                "localizedField": "USERDEFINEDQUANTITY_17",
                "tableName": "IDCUSTOMER",
                "label": "Quantity 17",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDQUANTITY_18",
                "localizedField": "USERDEFINEDQUANTITY_18",
                "tableName": "IDCUSTOMER",
                "label": "Quantity 18",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDQUANTITY_19",
                "localizedField": "USERDEFINEDQUANTITY_19",
                "tableName": "IDCUSTOMER",
                "label": "Quantity 19",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDQUANTITY_20",
                "localizedField": "USERDEFINEDQUANTITY_20",
                "tableName": "IDCUSTOMER",
                "label": "Quantity 20",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

        ]
    }
]
const RefrencesLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "CustomerUSERDEFINEDREFERENCE_1",
                "localizedField": "USERDEFINEDREFERENCE_1",
                "tableName": "IDCUSTOMER",
                "label": "Reference 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDREFERENCE_2",
                "localizedField": "USERDEFINEDREFERENCE_2",
                "tableName": "IDCUSTOMER",
                "label": "Reference 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDREFERENCE_3",
                "localizedField": "USERDEFINEDREFERENCE_3",
                "tableName": "IDCUSTOMER",
                "label": "Reference 3",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDREFERENCE_4",
                "localizedField": "USERDEFINEDREFERENCE_4",
                "tableName": "IDCUSTOMER",
                "label": "Reference 4",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDREFERENCE_5",
                "localizedField": "USERDEFINEDREFERENCE_5",
                "tableName": "IDCUSTOMER",
                "label": "Reference 5",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDREFERENCE_6",
                "localizedField": "USERDEFINEDREFERENCE_6",
                "tableName": "IDCUSTOMER",
                "label": "Reference 6",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDREFERENCE_7",
                "localizedField": "USERDEFINEDREFERENCE_7",
                "tableName": "IDCUSTOMER",
                "label": "Reference 7",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDREFERENCE_8",
                "localizedField": "USERDEFINEDREFERENCE_8",
                "tableName": "IDCUSTOMER",
                "label": "Reference 8",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDREFERENCE_9",
                "localizedField": "USERDEFINEDREFERENCE_9",
                "tableName": "IDCUSTOMER",
                "label": "Reference 9",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDREFERENCE_10",
                "localizedField": "USERDEFINEDREFERENCE_10",
                "tableName": "IDCUSTOMER",
                "label": "Reference 10",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

            {
                "name": "CustomerUSERDEFINEDREFERENCE_11",
                "localizedField": "USERDEFINEDREFERENCE_11",
                "tableName": "IDCUSTOMER",
                "label": "Reference 11",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDREFERENCE_12",
                "localizedField": "USERDEFINEDREFERENCE_12",
                "tableName": "IDCUSTOMER",
                "label": "Reference 12",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDREFERENCE_13",
                "localizedField": "USERDEFINEDREFERENCE_13",
                "tableName": "IDCUSTOMER",
                "label": "Reference 13",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDREFERENCE_14",
                "localizedField": "USERDEFINEDREFERENCE_14",
                "tableName": "IDCUSTOMER",
                "label": "Reference 14",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDREFERENCE_15",
                "localizedField": "USERDEFINEDREFERENCE_15",
                "tableName": "IDCUSTOMER",
                "label": "Reference 15",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDREFERENCE_16",
                "localizedField": "USERDEFINEDREFERENCE_16",
                "tableName": "IDCUSTOMER",
                "label": "Reference 16",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDREFERENCE_17",
                "localizedField": "USERDEFINEDREFERENCE_17",
                "tableName": "IDCUSTOMER",
                "label": "Reference 17",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDREFERENCE_18",
                "localizedField": "USERDEFINEDREFERENCE_18",
                "tableName": "IDCUSTOMER",
                "label": "Reference 18",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDREFERENCE_19",
                "localizedField": "USERDEFINEDREFERENCE_19",
                "tableName": "IDCUSTOMER",
                "label": "Reference 19",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerUSERDEFINEDREFERENCE_20",
                "localizedField": "USERDEFINEDREFERENCE_20",
                "tableName": "IDCUSTOMER",
                "label": "Reference 20",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },



        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "CustomerUSERDEFINEDCOMMENT",
                "localizedField": "USERDEFINEDCOMMENT",
                "tableName": "idCustomer",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    }
]

const ConsigneeCodesLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "ConsigneeUSERDEFINEDCODE_1",
                "localizedField": "USERDEFINEDCODE_1",
                "tableName": "IDCONSIGNEE",
                "label": "CODE 1",
                "type": "lookup","layout":IDCodesLookupLayout({codeType: '72' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDCODE_2",
                "localizedField": "USERDEFINEDCODE_2",
                "tableName": "IDCONSIGNEE",
                "label": "CODE 2",
                "type": "lookup","layout":IDCodesLookupLayout({codeType: '73' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDCODE_3",
                "localizedField": "USERDEFINEDCODE_3",
                "tableName": "IDCONSIGNEE",
                "label": "CODE 3",
                "type": "lookup","layout":IDCodesLookupLayout({codeType: '74' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDCODE_4",
                "localizedField": "USERDEFINEDCODE_4",
                "tableName": "IDCONSIGNEE",
                "label": "CODE 4",
                "type": "lookup","layout":IDCodesLookupLayout({codeType: '75' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDCODE_5",
                "localizedField": "USERDEFINEDCODE_5",
                "tableName": "IDCONSIGNEE",
                "label": "CODE 5",
                "type": "lookup","layout":IDCodesLookupLayout({codeType: '76' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDCODE_6",
                "localizedField": "USERDEFINEDCODE_6",
                "tableName": "IDCONSIGNEE",
                "label": "CODE 6",
                "type": "lookup","layout":IDCodesLookupLayout({codeType: '77' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDCODE_7",
                "localizedField": "USERDEFINEDCODE_7",
                "tableName": "IDCONSIGNEE",
                "label": "CODE 7",
                "type": "lookup","layout":IDCodesLookupLayout({codeType: '78' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDCODE_8",
                "localizedField": "USERDEFINEDCODE_8",
                "tableName": "IDCONSIGNEE",
                "label": "CODE 8",
                "type": "lookup","layout":IDCodesLookupLayout({codeType: '79' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDCODE_9",
                "localizedField": "USERDEFINEDCODE_9",
                "tableName": "IDCONSIGNEE",
                "label": "CODE 9",
                "type": "lookup","layout":IDCodesLookupLayout({codeType: '80' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDCODE_10",
                "localizedField": "USERDEFINEDCODE_10",
                "tableName": "IDCONSIGNEE",
                "label": "CODE 10",
                "type": "lookup","layout":IDCodesLookupLayout({codeType: '81' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

            {
                "name": "ConsigneeUSERDEFINEDCODE_11",
                "localizedField": "USERDEFINEDCODE_11",
                "tableName": "IDCONSIGNEE",
                "label": "CODE 11",
                "type": "lookup","layout":IDCodesLookupLayout({codeType: '3L' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDCODE_12",
                "localizedField": "USERDEFINEDCODE_12",
                "tableName": "IDCONSIGNEE",
                "label": "CODE 12",
                "type": "lookup","layout":IDCodesLookupLayout({codeType: '3M' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDCODE_13",
                "localizedField": "USERDEFINEDCODE_13",
                "tableName": "IDCONSIGNEE",
                "label": "CODE 13",
                "type": "lookup","layout":IDCodesLookupLayout({codeType: '3N' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDCODE_14",
                "localizedField": "USERDEFINEDCODE_14",
                "tableName": "IDCONSIGNEE",
                "label": "CODE 14",
                "type": "lookup","layout":IDCodesLookupLayout({codeType: '3O' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDCODE_15",
                "localizedField": "USERDEFINEDCODE_15",
                "tableName": "IDCONSIGNEE",
                "label": "CODE 15",
                "type": "lookup","layout":IDCodesLookupLayout({codeType: '3P' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDCODE_16",
                "localizedField": "USERDEFINEDCODE_16",
                "tableName": "IDCONSIGNEE",
                "label": "CODE 16",
                "type": "lookup","layout":IDCodesLookupLayout({codeType: '3Q' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDCODE_17",
                "localizedField": "USERDEFINEDCODE_17",
                "tableName": "IDCONSIGNEE",
                "label": "CODE 17",
                "type": "lookup","layout":IDCodesLookupLayout({codeType: '3R' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDCODE_18",
                "localizedField": "USERDEFINEDCODE_18",
                "tableName": "IDCONSIGNEE",
                "label": "CODE 18",
                "type": "lookup","layout":IDCodesLookupLayout({codeType: '3S' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDCODE_19",
                "localizedField": "USERDEFINEDCODE_19",
                "tableName": "IDCONSIGNEE",
                "label": "CODE 19",
                "type": "lookup","layout":IDCodesLookupLayout({codeType: '3T' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDCODE_20",
                "localizedField": "USERDEFINEDCODE_20",
                "tableName": "IDCONSIGNEE",
                "label": "CODE 20",
                "type": "lookup","layout":IDCodesLookupLayout({codeType: '3U' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "ConsigneeUSERDEFINEDDATE_1",
                "localizedField": "USERDEFINEDDATE_1",
                "tableName": "IDCONSIGNEE",
                "label": "Date 1",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDDATE_2",
                "localizedField": "USERDEFINEDDATE_2",
                "tableName": "IDCONSIGNEE",
                "label": "Date 2",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDDATE_3",
                "localizedField": "USERDEFINEDDATE_3",
                "tableName": "IDCONSIGNEE",
                "label": "Date 3",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDDATE_4",
                "localizedField": "USERDEFINEDDATE_4",
                "tableName": "IDCONSIGNEE",
                "label": "Date 4",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDDATE_5",
                "localizedField": "USERDEFINEDDATE_5",
                "tableName": "IDCONSIGNEE",
                "label": "Date 5",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDDATE_6",
                "localizedField": "USERDEFINEDDATE_6",
                "tableName": "IDCONSIGNEE",
                "label": "Date 6",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDDATE_7",
                "localizedField": "USERDEFINEDDATE_7",
                "tableName": "IDCONSIGNEE",
                "label": "Date 7",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDDATE_8",
                "localizedField": "USERDEFINEDDATE_8",
                "tableName": "IDCONSIGNEE",
                "label": "Date 8",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDDATE_9",
                "localizedField": "USERDEFINEDDATE_9",
                "tableName": "IDCONSIGNEE",
                "label": "Date 9",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDDATE_10",
                "localizedField": "USERDEFINEDDATE_10",
                "tableName": "IDCONSIGNEE",
                "label": "Date 10",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDDATE_11",
                "localizedField": "USERDEFINEDDATE_11",
                "tableName": "IDCONSIGNEE",
                "label": "Date 11",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDDATE_12",
                "localizedField": "USERDEFINEDDATE_12",
                "tableName": "IDCONSIGNEE",
                "label": "Date 12",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDDATE_13",
                "localizedField": "USERDEFINEDDATE_13",
                "tableName": "IDCONSIGNEE",
                "label": "Date 13",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDDATE_14",
                "localizedField": "USERDEFINEDDATE_14",
                "tableName": "IDCONSIGNEE",
                "label": "Date 14",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDDATE_15",
                "localizedField": "USERDEFINEDDATE_15",
                "tableName": "IDCONSIGNEE",
                "label": "Date 15",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDDATE_16",
                "localizedField": "USERDEFINEDDATE_16",
                "tableName": "IDCONSIGNEE",
                "label": "Date 16",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDDATE_17",
                "localizedField": "USERDEFINEDDATE_17",
                "tableName": "IDCONSIGNEE",
                "label": "Date 17",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDDATE_18",
                "localizedField": "USERDEFINEDDATE_18",
                "tableName": "IDCONSIGNEE",
                "label": "Date 18",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDDATE_19",
                "localizedField": "USERDEFINEDDATE_19",
                "tableName": "IDCONSIGNEE",
                "label": "Date 19",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDDATE_20",
                "localizedField": "USERDEFINEDDATE_20",
                "tableName": "IDCONSIGNEE",
                "label": "Date 20",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "ConsigneeUSERDEFINEDQUANTITY_1",
                "localizedField": "USERDEFINEDQUANTITY_1",
                "tableName": "IDCONSIGNEE",
                "label": "Quantity 1",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDQUANTITY_2",
                "localizedField": "USERDEFINEDQUANTITY_2",
                "tableName": "IDCONSIGNEE",
                "label": "Quantity 2",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDQUANTITY_3",
                "localizedField": "USERDEFINEDQUANTITY_3",
                "tableName": "IDCONSIGNEE",
                "label": "Quantity 3",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDQUANTITY_4",
                "localizedField": "USERDEFINEDQUANTITY_4",
                "tableName": "IDCONSIGNEE",
                "label": "Quantity 4",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDQUANTITY_5",
                "localizedField": "USERDEFINEDQUANTITY_5",
                "tableName": "IDCONSIGNEE",
                "label": "Quantity 5",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDQUANTITY_6",
                "localizedField": "USERDEFINEDQUANTITY_6",
                "tableName": "IDCONSIGNEE",
                "label": "Quantity 6",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDQUANTITY_7",
                "localizedField": "USERDEFINEDQUANTITY_7",
                "tableName": "IDCONSIGNEE",
                "label": "Quantity 7",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDQUANTITY_8",
                "localizedField": "USERDEFINEDQUANTITY_8",
                "tableName": "IDCONSIGNEE",
                "label": "Quantity 8",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDQUANTITY_9",
                "localizedField": "USERDEFINEDQUANTITY_9",
                "tableName": "IDCONSIGNEE",
                "label": "Quantity 9",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDQUANTITY_10",
                "localizedField": "USERDEFINEDQUANTITY_10",
                "tableName": "IDCONSIGNEE",
                "label": "Quantity 10",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

            {
                "name": "ConsigneeUSERDEFINEDQUANTITY_11",
                "localizedField": "USERDEFINEDQUANTITY_11",
                "tableName": "IDCONSIGNEE",
                "label": "Quantity 11",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDQUANTITY_12",
                "localizedField": "USERDEFINEDQUANTITY_12",
                "tableName": "IDCONSIGNEE",
                "label": "Quantity 12",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDQUANTITY_13",
                "localizedField": "USERDEFINEDQUANTITY_13",
                "tableName": "IDCONSIGNEE",
                "label": "Quantity 13",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDQUANTITY_14",
                "localizedField": "USERDEFINEDQUANTITY_14",
                "tableName": "IDCONSIGNEE",
                "label": "Quantity 14",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDQUANTITY_15",
                "localizedField": "USERDEFINEDQUANTITY_15",
                "tableName": "IDCONSIGNEE",
                "label": "Quantity 15",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDQUANTITY_16",
                "localizedField": "USERDEFINEDQUANTITY_16",
                "tableName": "IDCONSIGNEE",
                "label": "Quantity 16",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDQUANTITY_17",
                "localizedField": "USERDEFINEDQUANTITY_17",
                "tableName": "IDCONSIGNEE",
                "label": "Quantity 17",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDQUANTITY_18",
                "localizedField": "USERDEFINEDQUANTITY_18",
                "tableName": "IDCONSIGNEE",
                "label": "Quantity 18",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDQUANTITY_19",
                "localizedField": "USERDEFINEDQUANTITY_19",
                "tableName": "IDCONSIGNEE",
                "label": "Quantity 19",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDQUANTITY_20",
                "localizedField": "USERDEFINEDQUANTITY_20",
                "tableName": "IDCONSIGNEE",
                "label": "Quantity 20",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

        ]
    }
]
const ConsigneeCRefrencesLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "ConsigneeUSERDEFINEDREFERENCE_1",
                "localizedField": "USERDEFINEDREFERENCE_1",
                "tableName": "IDCONSIGNEE",
                "label": "Reference 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDREFERENCE_2",
                "localizedField": "USERDEFINEDREFERENCE_2",
                "tableName": "IDCONSIGNEE",
                "label": "Reference 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDREFERENCE_3",
                "localizedField": "USERDEFINEDREFERENCE_3",
                "tableName": "IDCONSIGNEE",
                "label": "Reference 3",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDREFERENCE_4",
                "localizedField": "USERDEFINEDREFERENCE_4",
                "tableName": "IDCONSIGNEE",
                "label": "Reference 4",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDREFERENCE_5",
                "localizedField": "USERDEFINEDREFERENCE_5",
                "tableName": "IDCONSIGNEE",
                "label": "Reference 5",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDREFERENCE_6",
                "localizedField": "USERDEFINEDREFERENCE_6",
                "tableName": "IDCONSIGNEE",
                "label": "Reference 6",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDREFERENCE_7",
                "localizedField": "USERDEFINEDREFERENCE_7",
                "tableName": "IDCONSIGNEE",
                "label": "Reference 7",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDREFERENCE_8",
                "localizedField": "USERDEFINEDREFERENCE_8",
                "tableName": "IDCONSIGNEE",
                "label": "Reference 8",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDREFERENCE_9",
                "localizedField": "USERDEFINEDREFERENCE_9",
                "tableName": "IDCONSIGNEE",
                "label": "Reference 9",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDREFERENCE_10",
                "localizedField": "USERDEFINEDREFERENCE_10",
                "tableName": "IDCONSIGNEE",
                "label": "Reference 10",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },

            {
                "name": "ConsigneeUSERDEFINEDREFERENCE_11",
                "localizedField": "USERDEFINEDREFERENCE_11",
                "tableName": "IDCONSIGNEE",
                "label": "Reference 11",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDREFERENCE_12",
                "localizedField": "USERDEFINEDREFERENCE_12",
                "tableName": "IDCONSIGNEE",
                "label": "Reference 12",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDREFERENCE_13",
                "localizedField": "USERDEFINEDREFERENCE_13",
                "tableName": "IDCONSIGNEE",
                "label": "Reference 13",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDREFERENCE_14",
                "localizedField": "USERDEFINEDREFERENCE_14",
                "tableName": "IDCONSIGNEE",
                "label": "Reference 14",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDREFERENCE_15",
                "localizedField": "USERDEFINEDREFERENCE_15",
                "tableName": "IDCONSIGNEE",
                "label": "Reference 15",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDREFERENCE_16",
                "localizedField": "USERDEFINEDREFERENCE_16",
                "tableName": "IDCONSIGNEE",
                "label": "Reference 16",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDREFERENCE_17",
                "localizedField": "USERDEFINEDREFERENCE_17",
                "tableName": "IDCONSIGNEE",
                "label": "Reference 17",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDREFERENCE_18",
                "localizedField": "USERDEFINEDREFERENCE_18",
                "tableName": "IDCONSIGNEE",
                "label": "Reference 18",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDREFERENCE_19",
                "localizedField": "USERDEFINEDREFERENCE_19",
                "tableName": "IDCONSIGNEE",
                "label": "Reference 19",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeUSERDEFINEDREFERENCE_20",
                "localizedField": "USERDEFINEDREFERENCE_20",
                "tableName": "IDCONSIGNEE",
                "label": "Reference 20",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },



        ]
    }
]
const WarehouseCodesLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "WarehouseUSERDEFINEDCODE_1",
                "localizedField": "USERDEFINEDCODE_1",
                "tableName": "IDWAREHOUSE",
                "label": "CODE 1",
                "type": "lookup", "layout": IDCodesLookupLayout({ codeType: 'K3' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDCODE_2",
                "localizedField": "USERDEFINEDCODE_2",
                "tableName": "IDWAREHOUSE",
                "label": "CODE 2",
                "type": "lookup", "layout": IDCodesLookupLayout({ codeType: 'K4' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDCODE_3",
                "localizedField": "USERDEFINEDCODE_3",
                "tableName": "IDWAREHOUSE",
                "label": "CODE 3",
                "type": "lookup", "layout": IDCodesLookupLayout({ codeType: 'K5' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDCODE_4",
                "localizedField": "USERDEFINEDCODE_4",
                "tableName": "IDWAREHOUSE",
                "label": "CODE 4",
                "type": "lookup", "layout": IDCodesLookupLayout({ codeType: 'K6' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDCODE_5",
                "localizedField": "USERDEFINEDCODE_5",
                "tableName": "IDWAREHOUSE",
                "label": "CODE 5",
                "type": "lookup", "layout": IDCodesLookupLayout({ codeType: 'K7' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDCODE_6",
                "localizedField": "USERDEFINEDCODE_6",
                "tableName": "IDWAREHOUSE",
                "label": "CODE 6",
                "type": "lookup", "layout": IDCodesLookupLayout({ codeType: 'K8' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDCODE_7",
                "localizedField": "USERDEFINEDCODE_7",
                "tableName": "IDWAREHOUSE",
                "label": "CODE 7",
                "type": "lookup", "layout": IDCodesLookupLayout({ codeType: 'K9' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDCODE_8",
                "localizedField": "USERDEFINEDCODE_8",
                "tableName": "IDWAREHOUSE",
                "label": "CODE 8",
                "type": "lookup", "layout": IDCodesLookupLayout({ codeType: 'L0' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDCODE_9",
                "localizedField": "USERDEFINEDCODE_9",
                "tableName": "IDWAREHOUSE",
                "label": "CODE 9",
                "type": "lookup", "layout": IDCodesLookupLayout({ codeType: 'L1' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDCODE_10",
                "localizedField": "USERDEFINEDCODE_10",
                "tableName": "IDWAREHOUSE",
                "label": "CODE 10",
                "type": "lookup", "layout": IDCodesLookupLayout({ codeType: 'L2' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "WarehouseUSERDEFINEDDATE_1",
                "localizedField": "USERDEFINEDDATE_1",
                "tableName": "IDWAREHOUSE",
                "label": "Date 1",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDDATE_2",
                "localizedField": "USERDEFINEDDATE_2",
                "tableName": "IDWAREHOUSE",
                "label": "Date 2",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDDATE_3",
                "localizedField": "USERDEFINEDDATE_3",
                "tableName": "IDWAREHOUSE",
                "label": "Date 3",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDDATE_4",
                "localizedField": "USERDEFINEDDATE_4",
                "tableName": "IDWAREHOUSE",
                "label": "Date 4",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDDATE_5",
                "localizedField": "USERDEFINEDDATE_5",
                "tableName": "IDWAREHOUSE",
                "label": "Date 5",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDDATE_6",
                "localizedField": "USERDEFINEDDATE_6",
                "tableName": "IDWAREHOUSE",
                "label": "Date 6",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDDATE_7",
                "localizedField": "USERDEFINEDDATE_7",
                "tableName": "IDWAREHOUSE",
                "label": "Date 7",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDDATE_8",
                "localizedField": "USERDEFINEDDATE_8",
                "tableName": "IDWAREHOUSE",
                "label": "Date 8",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDDATE_9",
                "localizedField": "USERDEFINEDDATE_9",
                "tableName": "IDWAREHOUSE",
                "label": "Date 9",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDDATE_10",
                "localizedField": "USERDEFINEDDATE_10",
                "tableName": "IDWAREHOUSE",
                "label": "Date 10",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "WarehouseUSERDEFINEDQUANTITY_1",
                "localizedField": "USERDEFINEDQUANTITY_1",
                "tableName": "IDWAREHOUSE",
                "label": "Quantity 1",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDQUANTITY_2",
                "localizedField": "USERDEFINEDQUANTITY_2",
                "tableName": "IDWAREHOUSE",
                "label": "Quantity 2",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDQUANTITY_3",
                "localizedField": "USERDEFINEDQUANTITY_3",
                "tableName": "IDWAREHOUSE",
                "label": "Quantity 3",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDQUANTITY_4",
                "localizedField": "USERDEFINEDQUANTITY_4",
                "tableName": "IDWAREHOUSE",
                "label": "Quantity 4",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDQUANTITY_5",
                "localizedField": "USERDEFINEDQUANTITY_5",
                "tableName": "IDWAREHOUSE",
                "label": "Quantity 5",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDQUANTITY_6",
                "localizedField": "USERDEFINEDQUANTITY_6",
                "tableName": "IDWAREHOUSE",
                "label": "Quantity 6",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDQUANTITY_7",
                "localizedField": "USERDEFINEDQUANTITY_7",
                "tableName": "IDWAREHOUSE",
                "label": "Quantity 7",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDQUANTITY_8",
                "localizedField": "USERDEFINEDQUANTITY_8",
                "tableName": "IDWAREHOUSE",
                "label": "Quantity 8",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDQUANTITY_9",
                "localizedField": "USERDEFINEDQUANTITY_9",
                "tableName": "IDWAREHOUSE",
                "label": "Quantity 9",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDQUANTITY_10",
                "localizedField": "USERDEFINEDQUANTITY_10",
                "tableName": "IDWAREHOUSE",
                "label": "Quantity 10",
                "type": "number", "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    }
]
const WarehouseRefrencesLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "WarehouseUSERDEFINEDREFERENCE_1",
                "localizedField": "USERDEFINEDREFERENCE_1",
                "tableName": "IDWAREHOUSE",
                "label": "Reference 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDREFERENCE_2",
                "localizedField": "USERDEFINEDREFERENCE_2",
                "tableName": "IDWAREHOUSE",
                "label": "Reference 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDREFERENCE_3",
                "localizedField": "USERDEFINEDREFERENCE_3",
                "tableName": "IDWAREHOUSE",
                "label": "Reference 3",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDREFERENCE_4",
                "localizedField": "USERDEFINEDREFERENCE_4",
                "tableName": "IDWAREHOUSE",
                "label": "Reference 4",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDREFERENCE_5",
                "localizedField": "USERDEFINEDREFERENCE_5",
                "tableName": "IDWAREHOUSE",
                "label": "Reference 5",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDREFERENCE_6",
                "localizedField": "USERDEFINEDREFERENCE_6",
                "tableName": "IDWAREHOUSE",
                "label": "Reference 6",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDREFERENCE_7",
                "localizedField": "USERDEFINEDREFERENCE_7",
                "tableName": "IDWAREHOUSE",
                "label": "Reference 7",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDREFERENCE_8",
                "localizedField": "USERDEFINEDREFERENCE_8",
                "tableName": "IDWAREHOUSE",
                "label": "Reference 8",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDREFERENCE_9",
                "localizedField": "USERDEFINEDREFERENCE_9",
                "tableName": "IDWAREHOUSE",
                "label": "Reference 9",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseUSERDEFINEDREFERENCE_10",
                "localizedField": "USERDEFINEDREFERENCE_10",
                "tableName": "IDWAREHOUSE",
                "label": "Reference 10",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }


        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "WarehouseUSERDEFINEDCOMMENT",
                "localizedField": "USERDEFINEDCOMMENT",
                "tableName": "IDWAREHOUSE",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
]
const AddressLayoutForVisible = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "AddressADDRESSNAME",
                "localizedField": "ADDRESSNAME",
                "tableName": "IDADDRESS",
                "label": "Address Name",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true,
            },
            {
                "name": "AddressADDRESS1",
                "localizedField": "ADDRESS_1",
                "tableName": "IDADDRESS",
                "label": "Address - 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true,
            },
            {
                "name": "AddressADDRESS2",
                "localizedField": "ADDRESS_2",
                "tableName": "IDADDRESS",
                "label": "Address - 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true,
            },
            {
                "name": "AddressCITY",
                "localizedField": "CITY",
                "tableName": "IDADDRESS",
                "label": "City",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true,
            },
            {
                "name": "AddressSTATE",
                "localizedField": "STATE",
                "tableName": "IDADDRESS",
                "label": "State",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true,
            },
            {
                "name": "AddressZIP",
                "localizedField": "ZIP",
                "tableName": "IDADDRESS",
                "label": "Zip",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true,
            },
            {
                "name": "AddressCOUNTY",
                "localizedField": "COUNTY",
                "tableName": "IDADDRESS",
                "label": "County",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true,
            },
            {
                "name": "AddressCOUNTRY",
                "localizedField": "COUNTRY",
                "tableName": "IDADDRESS",
                "label": "Country",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true,
            }
        ]
    }]
const AddressLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "AddressADDRESSNAME",
                "localizedField": "ADDRESSNAME",
                "tableName": "IDADDRESS",
                "label": "Address Name",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
                "readOnly":true,
            },
            {
                "name": "AddressADDRESS1",
                "localizedField": "ADDRESS_1",
                "tableName": "IDADDRESS",
                "label": "Address - 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AddressADDRESS2",
                "localizedField": "ADDRESS_2",
                "tableName": "IDADDRESS",
                "label": "Address - 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AddressCITY",
                "localizedField": "CITY",
                "tableName": "IDADDRESS",
                "label": "City",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AddressSTATE",
                "localizedField": "STATE",
                "tableName": "IDADDRESS",
                "label": "State",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AddressZIP",
                "localizedField": "ZIP",
                "tableName": "IDADDRESS",
                "label": "Zip",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AddressCOUNTY",
                "localizedField": "COUNTY",
                "tableName": "IDADDRESS",
                "label": "County",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AddressCOUNTRY",
                "localizedField": "COUNTRY",
                "tableName": "IDADDRESS",
                "label": "Country",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "fields": [
            {
                "name": "AddressTELEPHONE1",
                "localizedField": "TELEPHONE_1",
                "tableName": "IDADDRESS",
                "label": "Telephone - 1",
                "type": "phone",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AddressTELEPHONE2",
                "localizedField": "TELEPHONE_2",
                "tableName": "IDADDRESS",
                "label": "Telephone - 2",
                "type": "phone",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AddressFAX1",
                "localizedField": "FAX_1",
                "tableName": "IDADDRESS",
                "label": "Fax - 1",
                "type": "phone",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AddressFAX2",
                "localizedField": "FAX_2",
                "tableName": "IDADDRESS",
                "label": "Fax - 2",
                "type": "phone",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AddressCELLPHONE1",
                "localizedField": "CELLPHONE_1",
                "tableName": "IDADDRESS",
                "label": "Cell Phone - 1",
                "type": "phone",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AddressCELLPHONE2",
                "localizedField": "CELLPHONE_2",
                "tableName": "IDADDRESS",
                "label": "Cell Phone - 2",
                "type": "phone",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AddressPAGER1",
                "localizedField": "PAGER_1",
                "tableName": "IDADDRESS",
                "label": "Pager - 1",
                "type": "phone",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AddressPAGER2",
                "localizedField": "PAGER_2",
                "tableName": "IDADDRESS",
                "label": "Pager - 2",
                "type": "phone",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    }
    ,
    {
        "groupId": 4,
        "fields": [
            {
                "name": "AddressEMAILADDRESS1",
                "localizedField": "EMAILADDRESS_1",
                "tableName": "IDADDRESS",
                "label": "E- Email - 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AddressEMAILADDRESS2",
                "localizedField": "EMAILADDRESS_2",
                "tableName": "IDADDRESS",
                "label": "E- Email - 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AddressMODEM1",
                "localizedField": "MODEM_1",
                "tableName": "IDADDRESS",
                "label": "Modem - 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AddressMODEM2",
                "localizedField": "MODEM_2",
                "tableName": "IDADDRESS",
                "label": "Modem - 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AddressWEBSITEADDRESS1",
                "localizedField": "WEBSITEADDRESS_1",
                "tableName": "IDADDRESS",
                "label": "Web - 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AddressWEBSITEADDRESS2",
                "localizedField": "WEBSITEADDRESS_2",
                "tableName": "IDADDRESS",
                "label": "Web - 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
]
const AlterAddressLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "AlterAddressADDRESSNAME",
                "localizedField": "ADDRESSNAME",
                "tableName": "IDADDRESS",
                "label": "Address Name",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AlterAddressNAME",
                "localizedField": "ALTERNATENAME",
                "tableName": "IDADDRESS",
                "label": "Name",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AlterAddressADDRESS1",
                "localizedField": "ADDRESS_1",
                "tableName": "IDADDRESS",
                "label": "Address - 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AlterAddressADDRESS2",
                "localizedField": "ADDRESS_2",
                "tableName": "IDADDRESS",
                "label": "Address - 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AlterAddressCITY",
                "localizedField": "CITY",
                "tableName": "IDADDRESS",
                "label": "City",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AlterAddressSTATE",
                "localizedField": "STATE",
                "tableName": "IDADDRESS",
                "label": "State",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AlterAddressZIP",
                "localizedField": "ZIP",
                "tableName": "IDADDRESS",
                "label": "Zip",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AlterAddressCOUNTY",
                "localizedField": "COUNTY",
                "tableName": "IDADDRESS",
                "label": "County",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AlterAddressCOUNTRY",
                "localizedField": "COUNTRY",
                "tableName": "IDADDRESS",
                "label": "Country",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "fields": [
            {
                "name": "AlterAddressTELEPHONE1",
                "localizedField": "TELEPHONE_1",
                "tableName": "IDADDRESS",
                "label": "Telephone - 1",
                "type": "phone",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AlterAddressTELEPHONE2",
                "localizedField": "TELEPHONE_2",
                "tableName": "IDADDRESS",
                "label": "Telephone - 2",
                "type": "phone",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AlterAddressFAX1",
                "localizedField": "FAX_1",
                "tableName": "IDADDRESS",
                "label": "Fax - 1",
                "type": "phone",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AlterAddressFAX2",
                "localizedField": "FAX_2",
                "tableName": "IDADDRESS",
                "label": "Fax - 2",
                "type": "phone",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AlterAddressCELLPHONE1",
                "localizedField": "CELLPHONE_1",
                "tableName": "IDADDRESS",
                "label": "Cell Phone - 1",
                "type": "phone",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AlterAddressCELLPHONE2",
                "localizedField": "CELLPHONE_2",
                "tableName": "IDADDRESS",
                "label": "Cell Phone - 2",
                "type": "phone",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AlterAddressPAGER1",
                "localizedField": "PAGER_1",
                "tableName": "IDADDRESS",
                "label": "Pager - 1",
                "type": "phone",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AlterAddressPAGER2",
                "localizedField": "PAGER_2",
                "tableName": "IDADDRESS",
                "label": "Pager - 2",
                "type": "phone",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    }
    ,
    {
        "groupId": 4,
        "fields": [
            {
                "name": "AlterAddressEMAILADDRESS1",
                "localizedField": "EMAILADDRESS_1",
                "tableName": "IDADDRESS",
                "label": "E- Email - 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AlterAddressEMAILADDRESS2",
                "localizedField": "EMAILADDRESS_2",
                "tableName": "IDADDRESS",
                "label": "E- Email - 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AlterAddressMODEM1",
                "localizedField": "MODEM_1",
                "tableName": "IDADDRESS",
                "label": "Modem - 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AlterAddressMODEM2",
                "localizedField": "MODEM_2",
                "tableName": "IDADDRESS",
                "label": "Modem - 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AlterAddressWEBSITEADDRESS1",
                "localizedField": "WEBSITEADDRESS_1",
                "tableName": "IDADDRESS",
                "label": "Web - 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AlterAddressWEBSITEADDRESS2",
                "localizedField": "WEBSITEADDRESS_2",
                "tableName": "IDADDRESS",
                "label": "Web - 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
]
const AdditionalFormLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "CustomerR_TERMS",
                "localizedField": "R_TERMS",
                "tableName": "IDCUSTOMER",
                "label": "Terms",
                "type": "select",
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerR_TAXCODE",
                "localizedField": "R_TAXCODE",
                "tableName": "IDCUSTOMER",
                "label": "Tax Code",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "CustomerR_TAXCODE2",
                "localizedField": "R_TAXCODE2",
                "tableName": "IDCUSTOMER",
                "label": "Tax Code 2",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerBILLINGCYCLE",
                "localizedField": "BILLINGCYCLE",
                "tableName": "IDCUSTOMER",
                "label": "Billing Cycle",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerSTATUS",
                "localizedField": "STATUS",
                "tableName": "IDCUSTOMER",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerRESALENUMBER",
                "localizedField": "RESALENUMBER",
                "tableName": "IDCUSTOMER",
                "label": "Resale #",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "AR Control Account",
        "fields": [
            {
                "name": "CustomerARACCOUNT",
                "localizedField": "ARACCOUNT",
                "tableName": "IDCUSTOMER",
                "label": "AR Account",
                "type": "select",
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerR_GLDEPARTMENT",
                "localizedField": "R_GLDEPARTMENT",
                "tableName": "IDCUSTOMER",
                "label": "Department",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerR_GLFUND",
                "localizedField": "R_GLFUND",
                "tableName": "IDCUSTOMER",
                "label": "Fund",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerR_CAJOB",
                "localizedField": "R_CAJOB",
                "tableName": "IDCUSTOMER",
                "label": "Job",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "EDI Codes",
        "fields": [
            {
                "name": "CustomerR_TRADINGPARTNER",
                "localizedField": "R_TRADINGPARTNER",
                "tableName": "IDCUSTOMER",
                "label": "Trade Partner",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerSCAC",
                "localizedField": "SCAC",
                "tableName": "IDCUSTOMER",
                "label": "Scac",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            }
        ]
    },
    {
        "groupId": 4,
        "label": "Service Pricing",
        "fields": [
            {
                "name": "CustomerR_SERVICESPRICING",
                "localizedField": "R_SERVICESPRICING",
                "tableName": "IDCUSTOMER",
                "label": "Srv. Pricing",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerPOPUPMESSAGE",
                "localizedField": "POPUPMESSAGE",
                "tableName": "IDCUSTOMER",
                "label": "Popup Msg",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 5,
        "label": "ProShip shipments",
        "fields": [
            {
                "name": "CustomerSHIPSERVICECODE",
                "localizedField": "SHIPSERVICECODE",
                "tableName": "IDCUSTOMER",
                "label": "Ship Service",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerSHIPSERVICEACCOUNT",
                "localizedField": "SHIPSERVICEACCOUNT",
                "tableName": "IDCUSTOMER",
                "label": "Ship Account",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerSHIPSERVICELEVEL",
                "localizedField": "SHIPSERVICELEVEL",
                "tableName": "IDCUSTOMER",
                "label": "Ship Level",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    }
    ,
    {
        "groupId": 6,
        "label": "Validations",
        "fields": [
            {
                "name": "CustomerLOTEXPIRATIONDATECHECK",
                "localizedField": "LOTEXPIRATIONDATECHECK",
                "tableName": "IDCUSTOMER",
                "label": "Chk Lot Exp Date",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            }
        ]
    }
    ,
    {
        "groupId":7,
        "label": "Pay Groups",
        "fields": [
            {
                "name": "CustomerSETTLEMENTPAYGROUP",
                "localizedField": "SETTLEMENTPAYGROUP",
                "tableName": "IDCUSTOMER",
                "label": "Cust Group",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
    ,
    {
        "groupId": 8,
        "label": "Cash Receipts Entry",
        "fields": [
            {
                "name": "CustomerR_CASHRECEIPTSPORFILE",
                "localizedField": "R_CASHRECEIPTSPORFILE",
                "tableName": "IDCUSTOMER",
                "label": "Default Profile",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "CustomerCOMMENT",
                "localizedField": "COMMENT",
                "tableName": "IDCUSTOMER",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    }
    ,
    {
        "groupId": 9,
        "label": "SM Invoice",
        "fields": [
            {
                "name": "CustomerSMINVOICEEMAIL",
                "localizedField": "SMINVOICEEMAIL",
                "tableName": "IDCUSTOMER",
                "label": "Email Invoice",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 10,
        "label": "AR Open Item Entry",
        "fields": [
            {
                "name": "CustomerR_AROPENITEMDP",
                "localizedField": "R_AROPENITEMDP",
                "tableName": "IDCUSTOMER",
                "label": "AR Profile",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            }
        ]
    }

]
const WMDefaultsLayout = [
    {
        "groupId": 1,
        "label": "Item Consolidation",
        "fields": [
            {
                "name": "CustomerWMRICCONSOLIDATIONFLAG",
                "tableName": "IDCUSTOMER",
                "label": "Receipts",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerWMSICCONSOLIDATIONFLAG",
                "localizedField": "WMSICCONSOLIDATIONFLAG",
                "tableName": "IDCUSTOMER",
                "label": "Shipments",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerWMAICCONSOLIDATIONFLAG",
                "localizedField": "WMAICCONSOLIDATIONFLAG",
                "tableName": "IDCUSTOMER",
                "label": "Adjustments",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerWMCICCONSOLIDATIONFLAG",
                "localizedField": "WMCICCONSOLIDATIONFLAG",
                "tableName": "IDCUSTOMER",
                "label": "Storage",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "MiscConsolidated",
                "tableName": "IDCUSTOMER",
                "label": "Misc Charges",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "Item Frequency",
        "fields": [
            {
                "name": "CustomerWMRICFREQUENCY",
                "localizedField": "WMRICFREQUENCY",
                "tableName": "IDCUSTOMER",
                "label": "Receipt",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerWMSICFREQUENCY",
                "localizedField": "WMSICFREQUENCY",
                "tableName": "IDCUSTOMER",
                "label": "Shipments",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerWMAICFREQUENCY",
                "localizedField": "WMAICFREQUENCY",
                "tableName": "IDCUSTOMER",
                "label": "Adjustments",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerWMCICFREQUENCY",
                "localizedField": "WMCICFREQUENCY",
                "tableName": "IDCUSTOMER",
                "label": "Storage",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "MiscFrq",
                "tableName": "IDCUSTOMER",
                "label": "Misc Charges",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "Transaction Consolidation",
        "fields": [
            {
                "name": "CustomerWMRTCCONSOLIDATIONFLAG",
                "localizedField": "WMRTCCONSOLIDATIONFLAG",
                "tableName": "IDCUSTOMER",
                "label": "Receipt",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerWMSTCCONSOLIDATIONFLAG",
                "localizedField": "WMSTCCONSOLIDATIONFLAG",
                "tableName": "IDCUSTOMER",
                "label": "Shipments",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerWMATCCONSOLIDATIONFLAG",
                "localizedField": "WMATCCONSOLIDATIONFLAG",
                "tableName": "IDCUSTOMER",
                "label": "Adjustments",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerWMCTCCONSOLIDATIONFLAG",
                "localizedField": "WMCTCCONSOLIDATIONFLAG",
                "tableName": "IDCUSTOMER",
                "label": "Storage",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerWMMTCCONSOLIDATIONFLAG",
                "localizedField": "WMMTCCONSOLIDATIONFLAG",
                "tableName": "IDCUSTOMER",
                "label": "Misc Charges",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "Transaction Frequency",
        "fields": [
            {
                "name": "CustomerWMRTCFREQUENCY",
                "localizedField": "WMRTCFREQUENCY",
                "tableName": "IDCUSTOMER",
                "label": "Receipt",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerWMSTCFREQUENCY",
                "localizedField": "WMSTCFREQUENCY",
                "tableName": "IDCUSTOMER",
                "label": "Shipments",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerWMATCFREQUENCY",
                "localizedField": "WMATCFREQUENCY",
                "tableName": "IDCUSTOMER",
                "label": "Adjustments",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerWMCTCFREQUENCY",
                "localizedField": "WMCTCFREQUENCY",
                "tableName": "IDCUSTOMER",
                "label": "Storage",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerWMMTCFREQUENCY",
                "localizedField": "WMMTCFREQUENCY",
                "tableName": "IDCUSTOMER",
                "label": "Misc Charges",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 5,
        "label": "EDI / WEB Transaction Profiles",
        "fields": [
            {
                "name": "CustomerR_WMDEFAULTTRANSPROFILE",
                "localizedField": "R_WMDEFAULTTRANSPROFILE",
                "tableName": "IDCUSTOMER",
                "label": "Receipt",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerR_WMSHIPMENTPROFILE",
                "localizedField": "R_WMSHIPMENTPROFILE",
                "tableName": "IDCUSTOMER",
                "label": "Shipment",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerR_WMADJUSTMENTPROFILE",
                "localizedField": "R_WMADJUSTMENTPROFILE",
                "tableName": "IDCUSTOMER",
                "label": "Adjustment",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerR_WMDEFAULTITEMPROFILE",
                "localizedField": "R_WMDEFAULTITEMPROFILE",
                "tableName": "IDCUSTOMER",
                "label": "Item",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId":6,
        "label": "Data Entry",
        "fields": [
            {
                "name": "CustomerR_WMRATESCHEDULE",
                "localizedField": "R_WMRATESCHEDULE",
                "tableName": "IDCUSTOMER",
                "label": "WM Rate Scheduale",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId":7,
        "label": "Prefix",
        "fields": [
            {
                "name": "CustomerWMSHIPMENTSERIALNOPREFIX",
                "localizedField": "WMSHIPMENTSERIALNOPREFIX",
                "tableName": "IDCUSTOMER",
                "label": "Shipment SN",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerWMVICSBOLNOPREFIX",
                "localizedField": "WMVICSBOLNOPREFIX",
                "tableName": "IDCUSTOMER",
                "label": "VICs BOL No.",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 8,
        "label": "Minimum Charges",
        "fields": [
            {
                "name": "CustomerMINIMUMDAILYCHARGE",
                "localizedField": "MINIMUMDAILYCHARGE",
                "tableName": "IDCUSTOMER",
                "label": "Min Charge",
                "type": "number",
                "required": false,
                "visible": true,
                'format': "#,##0.00",
                "isLabelChanged": false,
            },
            {
                "name": "CustomerFREQUENCYCODE",
                "localizedField": "FREQUENCYCODE",
                "tableName": "IDCUSTOMER",
                "label": "Frequency",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerR_EVALUATIONEXPCODE",
                "localizedField": "R_EVALUATIONEXPCODE",
                "tableName": "IDCUSTOMER",
                "label": "Epr Code",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    }
]
const FMDefaultsLayout = [
    {
        "groupId": 1,
        "label": "Default Codes",
        "fields": [
            {
                "name": "CustomerR_FMDEFAULTTRANSPROFILE",
                "tableName": "IDCUSTOMER",
                "label": "FM Profile",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerR_FMDEFAULTDOPROFILE",
                "localizedField": "R_FMDEFAULTDOPROFILE",
                "tableName": "IDCUSTOMER",
                "label": "DO Profile",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "CustomerR_FMFREIGHTCHARGE",
                "localizedField": "R_FMFREIGHTCHARGE",
                "tableName": "IDCUSTOMER",
                "label": "FB Charge Cd",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerR_FMFREIGHTCODE",
                "localizedField": "R_FMFREIGHTCODE",
                "tableName": "IDCUSTOMER",
                "label": "FB Freight Cd",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerFMCONSOLIDATEDINVOICE",
                "localizedField": "FMCONSOLIDATEDINVOICE",
                "tableName": "IDCUSTOMER",
                "label": "Consolidation",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "CustomerPOREQUIREMENTFLAG",
                "localizedField": "POREQUIREMENTFLAG",
                "tableName": "IDCUSTOMER",
                "label": "Req'd B/L",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerBOLREQUIREMENTFLAG",
                "localizedField": "BOLREQUIREMENTFLAG",
                "tableName": "IDCUSTOMER",
                "label": "Req'd PO#",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "CustomerFMINVOICECOMMITFLAG",
                "localizedField": "FMINVOICECOMMITFLAG",
                "tableName": "IDCUSTOMER",
                "label": "FM Inv Commit",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "CustomerFMAROPENITEMDESC",
                "localizedField": "FMAROPENITEMDESC",
                "tableName": "IDCUSTOMER",
                "label": "AR Open Item",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "CustomerR_RATESCHEDULE",
                "localizedField": "R_RATESCHEDULE",
                "tableName": "IDCUSTOMER",
                "label": "Rate Schedule",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "CustomerFMWEIGHTBASE",
                "localizedField": "FMWEIGHTBASED",
                "tableName": "IDCUSTOMER",
                "label": "Weight Base",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "Mileage Applications",
        "fields": [
            {
                "name": "CustomerFMDEFAULTMILESCALCULATIONBASIS",
                "localizedField": "FMDEFAULTMILESCALCULATIONBASIS",
                "tableName": "IDCUSTOMER",
                "label": "Mileage Calc",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerFMPAYMILEAGEAPP",
                "localizedField": "FMPAYMILEAGEAPP",
                "tableName": "IDCUSTOMER",
                "label": "Bilable Miles",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerLIMIT53TRL",
                "localizedField": "LIMIT53TRL",
                "tableName": "IDCUSTOMER",
                "label": "5'3 Routing",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "Documents Delivery",
        "fields": [
            {
                "name": "CustomerR_FMBATCHPRINT",
                "localizedField": "R_FMBATCHPRINT",
                "tableName": "IDCUSTOMER",
                "label": "FM Batch Print",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }

]
const CreditLayout = [
    {
        "groupId": 1,
        "label": "Credit Information",
        "fields": [
            {
                "name": "CustomerCREDITSTATUSFLAG",
                "tableName": "IDCUSTOMER",
                "label": "Credit Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerCREDITRATING",
                "tableName": "IDCUSTOMER",
                "label": "Rating",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerCREDITLIMIT",
                "localizedField": "CREDITLIMIT",
                "tableName": "IDCUSTOMER",
                "label": "Limit",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerCREDITLASTREVIEWDATE",
                "tableName": "IDCUSTOMER",
                "label": "Last Review",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerCREDITNEXTREVIEWDATE",
                "tableName": "IDCUSTOMER",
                "label": "Next Review",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "CustomerDATEOPENED",
                "tableName": "IDCUSTOMER",
                "label": "Date Opened",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerHIGHESTSTATEMENTBALANCE",
                "tableName": "IDCUSTOMER",
                "label": "High Balance",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "CustomerCREDITCOMMENT",
                "tableName": "IDCUSTOMER",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    }
]
const OMDefaultsLayout = [
    {
        "groupId": 1,
        "label": "Sales Order Entry",
        "fields": [
            {
                "name": "CustomerSOINVENTORYPRICELEVEL",
                "localizedField": "SOINVENTORYPRICELEVEL",
                "tableName": "IDCUSTOMER",
                "label": "Price Level",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerR_PRICESHEDULE",
                "localizedField": "R_PRICESHEDULE",
                "tableName": "IDCUSTOMER",
                "label": "Price Sched",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerNORMALOPENDAYS",
                "localizedField": "NORMALOPENDAYS",
                "tableName": "IDCUSTOMER",
                "label": "Open Days",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerPARTIALSHIPMENT",
                "localizedField": "PARTIALSHIPMENT",
                "tableName": "IDCUSTOMER",
                "label": "Partial Ship",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerR_OMDEFAULTTRANSPROFILE",
                "localizedField": "R_OMDEFAULTTRANSPROFILE",
                "tableName": "IDCUSTOMER",
                "label": "Profile",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "CustomerR_DEFAULTSHIPTO",
                "localizedField": "R_DEFAULTSHIPTO",
                "tableName": "IDCUSTOMER",
                "label": "Ship To",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerTAXCODESOURCE",
                "localizedField": "TAXCODESOURCE",
                "tableName": "IDCUSTOMER",
                "label": "Tax Code Source",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "CustomerOMREQUIREPO",
                "localizedField": "OMREQUIREPO",
                "tableName": "IDCUSTOMER",
                "label": "Require PO",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },


    {
        "groupId": 2,
        "label": "Print Flags",
        "fields": [
            {
                "name": "CustomerOMPRINTPICKSLIP",
                "localizedField": "OMPRINTPICKSLIP",
                "tableName": "IDCUSTOMER",
                "label": "Pick Slip",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerOMPRINTORDERACKNOWLEDGEMENT",
                "localizedField": "OMPRINTORDERACKNOWLEDGEMENT",
                "tableName": "IDCUSTOMER",
                "label": "Order Acknowledgement",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerOMPRINTDELIVERYNOTIFICATION",
                "localizedField": "OMPRINTDELIVERYNOTIFICATION",
                "tableName": "IDCUSTOMER",
                "label": "Notification",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerOMPRINTPACKINGSLIP",
                "localizedField": "OMPRINTPACKINGSLIP",
                "tableName": "IDCUSTOMER",
                "label": "Packing Slip",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "CustomerOMPRINTINVOICE",
                "localizedField": "OMPRINTINVOICE",
                "tableName": "IDCUSTOMER",
                "label": "Invoice",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerOMPRINTBOL",
                "localizedField": "OMPRINTBOL",
                "tableName": "IDCUSTOMER",
                "label": "BOL",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "CustomerOMSENDFAX",
                "localizedField": "OMSENDFAX",
                "tableName": "IDCUSTOMER",
                "label": "Send Fax",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "CustomerOMSENDEMAIL",
                "localizedField": "OMSENDEMAIL",
                "tableName": "IDCUSTOMER",
                "label": "Send Email",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }]
    },
    {
        "groupId": 3,
        "label": "Report Formats",
        "fields": [
            {
                "name": "CustomerOMPICKINGSLIPREPORTTYPE",
                "localizedField": "OMPICKINGSLIPREPORTTYPE",
                "tableName": "IDCUSTOMER",
                "label": "Picking Slip Report",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PickSlipFormat",
                "tableName": "IDCUSTOMER",
                "label": "Pick Slip Format",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "CustomerOMINVOICEREPORTTYPE",
                "localizedField": "OMINVOICEREPORTTYPE",
                "tableName": "IDCUSTOMER",
                "label": "Invoice Report",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "InvoiceFormat",
                "tableName": "IDCUSTOMER",
                "label": "Invoice Format",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerOMORDERACKNREPORTTYPE",
                "localizedField": "OMORDERACKNREPORTTYPE",
                "tableName": "IDCUSTOMER",
                "label": "Order Ackn Report",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "OrderAcknFormat",
                "tableName": "IDCUSTOMER",
                "label": "Order Ackn Format",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "Discounts",
        "fields": [


            {
                "name": "CustomerCUSTOMERPURCHASEDISCOUNT",
                "localizedField": "CUSTOMERPURCHASEDISCOUNT",
                "tableName": "IDCUSTOMER",
                "label": "Trade Disc %",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerDISCOUNTTYPE",
                "localizedField": "DISCOUNTTYPE",
                "tableName": "IDCUSTOMER",
                "label": "Discount Type",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerR_DISCOUNTTABLE",
                "localizedField": "R_DISCOUNTTABLE",
                "tableName": "IDCUSTOMER",
                "label": "Discount Table",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 5,
        "label": "Calculate Credit OM Orders",
        "fields": [
            {
                "name": "CustomerCREDITOMORDERS",
                "localizedField": "CREDITOMORDERS",
                "tableName": "IDCUSTOMER",
                "label": "Form Stage",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 6,
        "label": "CardConnect Profile",
        "fields": [
            {
                "name": "PaymentProfile",
                "localizedField": "PaymentProfile",
                "tableName": "IDCUSTOMER",
                "label": "Pay Profile",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 7,
        "label": "IM Customer Cross Reference",
        "fields": [
            {
                "name": "CustomerIMCRGROUP",
                "localizedField": "IMCRGROUP",
                "tableName": "IDCUSTOMER",
                "label": "Group",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }]
    },
    {
        "groupId": 8,
        "label": "Electronic Payment",
        "fields": [
            {
                "name": "CustomerPAYMENTSYSTEM",
                "localizedField": "PAYMENTSYSTEM",
                "tableName": "IDCUSTOMER",
                "label": "Payment System",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "CustomerPAYMENTTHRESHOLD",
                "localizedField": "PAYMENTTHRESHOLD",
                "tableName": "IDCUSTOMER",
                "label": "Max Limit",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }

        ]
    },
]

const HistoryLayout = [
    {
        "groupId": 1,
        "label": "Transaction",
        "fields": [
            {
                "name": "TransactionDate",
                "tableName": "IDCUSTOMER",
                "label": "Date",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "Amount",
                "tableName": "IDCUSTOMER",
                "label": "Amount",
                "format":"$ #,##0.00",
                "type": "number",
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TransactionNumber",
                "tableName": "IDCUSTOMER",
                "label": "Transaction #",
                "type": "text",
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TransactionType",
                "tableName": "IDCUSTOMER",
                "label": "Type",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            }
        ]
    },
    {
        "groupId": 2,
        "label": "Cash Receipt",
        "fields": [
            {
                "name": "LastPaymentDate",
                "tableName": "IDCUSTOMER",
                "label": "Date",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "LastPaymentAmount",
                "tableName": "IDCUSTOMER",
                "label": "Amount",
                "type": "number",
                "format":"$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "LastPaymentReference",
                "tableName": "IDCUSTOMER",
                "label": "Reference",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            }

        ]
    },
    {
        "groupId": 3,
        "label": "Finance Charges",
        "fields": [
            {
                "name": "FinanceChargeDate",
                "tableName": "IDCUSTOMER",
                "label": "Date",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "FinanceChargeAmount",
                "tableName": "IDCUSTOMER",
                "label": "Amount",
                "type": "number",
                "format":"$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            },
            {
                "name": "YtdCharge",
                "tableName": "IDCUSTOMER",
                "label": "YTD Amount",
                "format":"$ #,##0.00",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,

            }
        ]
    }
]
const SummaryLayout = [
    {
        "groupId": 1,
        "label": "MTD",
        "fields": [
            {
                "name": "InvoiceMTD",
                "tableName": "IDCUSTOMER",
                "label": "Invoice/Debit",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaymentMTD",
                "tableName": "IDCUSTOMER",
                "label": "Payments",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DiscountMTD",
                "tableName": "IDCUSTOMER",
                "label": "Disc/Cash Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CreditMTD",
                "tableName": "IDCUSTOMER",
                "label": "Credit/Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            

            {
                "name": "PostedMTD",
                "tableName": "IDCUSTOMER",
                "label": "Posted",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidMTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidDueDateMTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid Due Date",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidLateMTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid Late",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AvgDaysPayMTD",
                "tableName": "IDCUSTOMER",
                "label": "Avg Days Pay",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "YTD",
        "fields": [
            {
                "name": "InvoiceYTD",
                "tableName": "IDCUSTOMER",
                "label": "Invoice/Debit",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaymentYTD",
                "tableName": "IDCUSTOMER",
                "label": "Payments",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DiscountYTD",
                "tableName": "IDCUSTOMER",
                "label": "Disc/Cash Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CreditYTD",
                "tableName": "IDCUSTOMER",
                "label": "Credit/Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            

            {
                "name": "PostedYTD",
                "tableName": "IDCUSTOMER",
                "label": "Posted",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidYTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidDueDateYTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid Due Date",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidLateYTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid Late",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AvgDaysPayYTD",
                "tableName": "IDCUSTOMER",
                "label": "Avg Days Pay",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "LTD",
        "fields": [
            {
                "name": "InvoiceLTD",
                "tableName": "IDCUSTOMER",
                "label": "Invoice/Debit",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaymentLTD",
                "tableName": "IDCUSTOMER",
                "label": "Payments",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DiscountLTD",
                "tableName": "IDCUSTOMER",
                "label": "Disc/Cash Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CreditLTD",
                "tableName": "IDCUSTOMER",
                "label": "Credit/Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            

            {
                "name": "PostedLTD",
                "tableName": "IDCUSTOMER",
                "label": "Posted",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidLTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidDueDateLTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid Due Date",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidLateLTD",
                "tableName": "IDCUSTOMER",
                "label": "Paid Late",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AvgDaysPayLTD",
                "tableName": "IDCUSTOMER",
                "label": "Avg Days Pay",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId":4,
        "label": "Prior Year",
        "fields": [
            {
                "name": "InvoicePriorY",
                "tableName": "IDCUSTOMER",
                "label": "Invoice/Debit",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaymentPriorY",
                "tableName": "IDCUSTOMER",
                "label": "Payments",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DiscountPriorY",
                "tableName": "IDCUSTOMER",
                "label": "Disc/Cash Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CreditPriorY",
                "tableName": "IDCUSTOMER",
                "label": "Credit/Adjust",
                "type": "number",
                'format': "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            

            {
                "name": "PostedPriorY",
                "tableName": "IDCUSTOMER",
                "label": "Posted",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidPriorY",
                "tableName": "IDCUSTOMER",
                "label": "Paid",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidDueDatePriorY",
                "tableName": "IDCUSTOMER",
                "label": "Paid Due Date",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "PaidLatePriorY",
                "tableName": "IDCUSTOMER",
                "label": "Paid Late",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "AvgDaysPayPriorY",
                "tableName": "IDCUSTOMER",
                "label": "Avg Days Pay",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 5,
        "label": "Balance Information",
        "fields": [
            {
                "name": "CurrentBalance",
                "tableName": "IDCUSTOMER",
                "label": "Current Balance",
                "type": "number",
                "format":"$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerLASTSTATEMENTBALANCE",
                "localizedField": "LASTSTATEMENTBALANCE",
                "tableName": "IDCUSTOMER",
                "label": "Last Stm Bal",
                "type": "number",
                "format":"$ #,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CustomerLASTSTATEMENTDATE",
                "localizedField": "LASTSTATEMENTDATE",
                "tableName": "IDCUSTOMER",
                "label": "Last Statement",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
        }
]
const EdiDefaultLayout = [
    {
        "groupId": 1,
        "label": "EDI Codes",
        "fields": [
            {
                "name": "ConsigneeRTRADINGPARTNER",
                "tableName": "IDCONSIGNEE",
                "localizedField": "R_TRADINGPARTNER",
                "label": "Trade Partner",
                "type": "lookup",
                "layout": IDTradingPartnerLookupLayout({ type: 'consignee'}),
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
            ,
            {
                "name": "ConsigneeIDQUALIFIER",
                "tableName": "IDCONSIGNEE",
                "localizedField": "IDQUALIFIER",
                "label": "ID Qualifier",
                "type": "lookup",
                 "layout":EDLookupLayout({ Dataelementnum: '66' ,Versionid: '4010'}),
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "ConsigneeIDCODE",
                "tableName": "IDCONSIGNEE",
                "localizedField": "IDCODE",
                "label": "ID Code",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "ConsigneeLOCATIONQUALIFIER",
                "tableName": "IDCONSIGNEE",
                "localizedField": "LOCATIONQUALIFIER",
                "label": "Locn Qualifier",
                "type": "lookup",
                "layout":EDLookupLayout({ Dataelementnum: '309' ,Versionid: '4010'}),
                "required": false,
                "visible": true,
                "isLabelChanged": false
            },
            {
                "name": "ConsigneeLOCATIONIDENTIFIER",
                "tableName": "IDCONSIGNEE",
                "localizedField": "LOCATIONIDENTIFIER",
                "label": "Locn Code",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false

            }
        ]
    }
]
const ConsigneeWMDefaultLayout = [
    {
        "groupId": 1,
        "label": "Expiration Days",
        "fields": [
            {
                "name": "ConsigneeWMEXPIRATIONDAYS",
                "tableName": "IDCONSIGNEE",
                "localizedField": "WMEXPIRATIONDAYS",
                "label": "WM Expiraton Days",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false
            }
        ]
    }
]


const ConsigneeAdditionalLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "ConsigneeSTATUS",
                "localizedField": "STATUS",
                "tableName": "IDCONSIGNEE",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeLOCATION",
                "localizedField": "LOCATION",
                "tableName": "IDCONSIGNEE",
                "label": "Location",
                "type": "lookup",
                "layout":IDCodesLookupLayout({codeType: '02' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneePOPUPMESSAGE",
                "localizedField": "POPUPMESSAGE",
                "tableName": "IDCONSIGNEE",
                "label": "Popup Message",
                "layout":ABPopupMessageLayout({ tableName: 'IDCONSIGNEE' }),
                "type": "lookup",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeDELIVERYROUTE",
                "localizedField": "DELIVERYROUTE",
                "tableName": "IDCONSIGNEE",
                "label": "Delivery Route",
                "type": "lookup",
                "layout":IDCodesLookupLayout({codeType: '2B' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeFMSTOPNO",
                "localizedField": "FMSTOPNO",
                "tableName": "IDCONSIGNEE",
                "label": "Stop No.",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "ConsigneeCOMMENT",
                "localizedField": "COMMENT",
                "tableName": "IDCONSIGNEE",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
    ,
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "ConsigneeDIRECTIONS",
                "localizedField": "DIRECTIONS",
                "tableName": "IDCONSIGNEE",
                "label": "Directions",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
]
const ConsigneeOmDefaultLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "ConsigneeSOINVENTORYPRICELEVEL",
                "localizedField": "SOINVENTORYPRICELEVEL",
                "tableName": "IDCONSIGNEE",
                "label": "Price Level",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeRPRICESCHEDULE",
                "localizedField": "RPRICESCHEDULE",
                "tableName": "IDCONSIGNEE",
                "label": "Price Sched",
                "type": "lookup",
                "layout":IMPriceScheduleLookupLayout(),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeRSHIPVIA",
                "tableName": "IMITEM",
                "label": "Ship Via",
                "type": "lookup",
                "layout": IDShipViaLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }, {
                "name": "ConsigneeRPARTICIPANT",
                "tableName": "IMITEM",
                "label": "Salesperson",
                "type": "lookup",
                "layout": IDParticipantLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },{
                "name": "ConsigneeRPRODUCTCATEGORY",
                "tableName": "IMITEM",
                "label": "Product Category",
                "type": "lookup",
                "layout": IMProductCategoryLookupLayout(),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },{
                "name": "ConsigneeRTAX",
                "tableName": "IMITEM",
                "label": "Tax",
                "type": "lookup",
                "layout": IDTaxHeaderLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },{
                "name": "ConsigneeRDEPARTMENT",
                "tableName": "IMITEM",
                "label": "Department",
                "type": "lookup",
                "layout": ACDepartmentLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeRFUND",
                "tableName": "IMITEM",
                "label": "Fund",
                "type": "lookup",
                "layout": FAFundLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeRJOB",
                "tableName": "IMITEM",
                "label": "Job",
                "type": "lookup",
                "layout": CAJobLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeOMVISIBLE",
                "localizedField": "OMVISIBLE",
                "tableName": "IDCONSIGNEE",
                "label": "Visible in OM",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
           
        ]
    },{
        "groupId": 2,
        "label": "Consignment Warehouses",
        "fields": [
            {
                "name": "ConsigneeRWHITEM",
                "tableName": "IMITEM",
                "label": "Item WH",
                "type": "lookup",
                "layout": IDWarehouseLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },{
                "name": "ConsigneeRWHLOCATION",
                "tableName": "IMITEM",
                "label": "Location WH",
                "type": "lookup",
                "layout": IDWarehouseLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            } , {
                "name": "ConsigneeCONSIGNMENTUNITS",
                "localizedField": "CONSIGNMENTUNITS",
                "tableName": "IDCONSIGNEE",
                "label": "Convert Units",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ConsigneeRCONSIGNMENTPRODUCTCATEGORY",
                "tableName": "IMITEM",
                "label": "Product Category Consignment",
                "type": "lookup",
                "layout": IMProductCategoryLookupLayout(),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
           
        ]
    }
]
const WarehouseAdditionalLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "WarehouseSTATUS",
                "localizedField": "STATUS",
                "tableName": "IDWAREHOUSE",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehousePOPUPMESSAGE",
                "localizedField": "POPUPMESSAGE",
                "tableName": "IDWAREHOUSE",
                "label": "Popup Message",
                "layout":ABPopupMessageLayout({ tableName: 'IDWAREHOUSE' }),
                "type": "lookup",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "Exception and Week Settings",
        "fields": [
            {
                "name": "WarehouseREXCEPTIONS",
                "localizedField": "R_EXCEPTIONS",
                "tableName": "IDWAREHOUSE",
                "label": "Exceptions",
                "layout":IDExceptionCodeLookupLayout,
                "type": "lookup",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "WarehouseRWEEKSETTINGS",
                "localizedField": "R_WEEKSETTINGS",
                "tableName": "IDWAREHOUSE",
                "label": "Week Settings",
                "layout":IDWeekSettingsLookupLayout,
                "type": "lookup",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
]
export {
    PrimaryLayout,
    CodesLayout,
    RefrencesLayout,
    AddressLayout,
    AdditionalFormLayout,
    WMDefaultsLayout,
    FMDefaultsLayout,
    CreditLayout,
    OMDefaultsLayout,

    HistoryLayout,
    SummaryLayout,
    AlterAddressLayout,
    AddressLayoutForVisible,
    ConsigneeCodesLayout,
    ConsigneeCRefrencesLayout,
    ConsigneeAdditionalLayout,
    EdiDefaultLayout,
    ConsigneeWMDefaultLayout,
    ConsigneeOmDefaultLayout,
    WarehouseAdditionalLayout,
    WarehouseCodesLayout,
    WarehouseRefrencesLayout
}